<template>
  <v-card flat tile color="primary" class="d-flex justify-center align-center pt-4" 
    style="position: fixed; top: 0; left: 0; right: 0; z-index: 99999; height: 2rem;"
    v-if="int_isInDemoMode"
  >
    <p class="white--text">Running in demo mode. Changes will not be saved. <a href="/" class="font-bold white--text">Learn more</a></p>
  </v-card>
</template>

<script>
export default {
  props: ["isInDemoMode"],
  data() {
    return {
      int_isInDemoMode: false
    }
  },
  async mounted() {
    if (this.isInDemoMode !== undefined) {
      this.int_isInDemoMode = this.isInDemoMode;
    }


    if (window.location.pathname.toLowerCase().startsWith("/demo")) {
      this.int_isInDemoMode = true;
    }
  }
}
</script>